import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../firebase'
import StateContext from '../../StateContext'
import FixtureTemplate from '../Public/Fixtures/FixtureTemplate'

function UserFavoritedFixtures() {

    const appState = useContext(StateContext)
    const [fixtures, setFixtures] = useState([])

    useEffect(() => {

        try {
            const favFixturesRef = firestore.collection("users").doc(appState.userId).collection("favoriteFixtures");
            favFixturesRef.onSnapshot(({docs}) => {
                const fixtures = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setFixtures(fixtures)
            })
        } catch (error) {
            
        }

    }, [appState.userId])

    return (
        <div>
            {fixtures?.map((fixture, index) => {
                return (
                    <FixtureTemplate key={index} fixture={fixture} fixtureId={fixture.fixtureId} type="favorited" />
                )
            })}
        </div>
    )

}
export default UserFavoritedFixtures